/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CLAN_QUEST_TUTORIAL_TITLE = (
    <FormattedMessage
        id="clan_quests.tutorial.title"
        defaultMessage='БОЕВЫЕ ПОХОДЫ'
    />
)

export const CLAN_QUEST_TUTORIAL_DESCRIPTION = (
    <FormattedMessage
        id="clan_quests.tutorial.description"
        defaultMessage='Боевые походы — регулярные игровые события, в которых игроки одного клана совместными усилиями заполняют шкалу продвижения. За достижение указанных значений прогресса игроки клана получают ценные награды.'
    />
)

export const AFFIRMATIVE_BUTTON = (
    <FormattedMessage
        id='clan_quests.tutorial.affirmative.button'
        defaultMessage='Так точно!'
    />
)

export const PAGE_2_TITLE = (
    <FormattedMessage
        id="clan_quests.tutorial.page2.title"
        defaultMessage='Зарабатывайте очки'
    />
)

export const PAGE_2_DESCRIPTION = (
    <FormattedMessage
        id="clan_quests.tutorial.page2.description"
        defaultMessage='Выполняйте поручения, чтобы заработать очки личного вклада и очки похода.{brTag}{brTag}Достигайте кланом цели похода, чтобы заработать ещё больше очков.'
        values={{
            brTag: <br/>,
        }}
    />
)

export const PAGE_3_TITLE = (
    <FormattedMessage
        id="clan_quests.tutorial.page3.title"
        defaultMessage='Продвигайтесь вперёд'
    />
)

export const PAGE_3_DESCRIPTION = (
    <FormattedMessage
        id="clan_quests.tutorial.page3.description"
        defaultMessage='Заработанные очки увеличивают ваш личный вклад и продвигают поход.'
    />
)

export const PAGE_4_TITLE = (
    <FormattedMessage
        id="clan_quests.tutorial.page4.title"
        defaultMessage='Получайте награды'
    />
)

export const PAGE_4_DESCRIPTION = (
    <FormattedMessage
        id="clan_quests.tutorial.page4.description"
        defaultMessage='За личный вклад вы получаете награды, а за продвижение похода — трофеи. Это более ценные призы.'
    />
)



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanQuestsTutorial/translations.jsx